import React from "react"
import cx from "classnames"
import { Icon } from "@/components/ui"
import { constants } from "helpers"

type ChainCurrencyProps = {
  className?: string
  chainClassName?: string
  chainId: any
  size: 4 | 5
  borderColor?: "accent-grey-900" | "accent-grey-1000" | "accent-grey-700"
  withGrayscale?: boolean
  currencyIcon?: string
}

const ChainCurrency: React.FC<ChainCurrencyProps> = React.memo(
  ({
    className,
    chainClassName,
    chainId,
    size,
    withGrayscale,
    currencyIcon,
  }) => {
    return (
      <div className={cx("flex items-center", className)}>
        <div
          className={cx(
            "border-2 rounded-full z-10 transition-colors",
            chainClassName
          )}
        >
          <Icon
            className={`size-${size}`}
            name={constants.chainIcons[chainId]}
          />
        </div>
        <Icon
          className={cx("-ml-1", `size-${size}`, { grayscale: withGrayscale })}
          name={currencyIcon || constants.currencyIcons[chainId]}
        />
      </div>
    )
  }
)

export default ChainCurrency
